import { Flex } from 'antd'

import Breadcrumb from 'component/breadcrumb/breadcrumb'
import { BREADCRUMBS } from 'constants/breadcrumb'
import { PromoCodeTable } from 'modules/promo-code/promo-code-table'

import './styles.scss'

const PromoCode = () => {
  const breadCrumbItems = [BREADCRUMBS.PROMO_CODE]

  return (
    <Flex vertical gap={24} className="promo-code">
      <Breadcrumb additionalItems={breadCrumbItems} />

      <PromoCodeTable />
    </Flex>
  )
}

export default PromoCode
